var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningIconDynamic = function SvgWarningIconDynamic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0844 14.7132L13.0194 1.72581C11.8843 -0.185166 9.11722 -0.187705 7.98058 1.72581L0.915894 14.7132C-0.244497 16.6659 1.16039 19.1386 3.43472 19.1386H17.565C19.8375 19.1386 21.2448 16.6679 20.0844 14.7132ZM10.5 16.7948C9.85398 16.7948 9.32812 16.269 9.32812 15.623C9.32812 14.9769 9.85398 14.4511 10.5 14.4511C11.146 14.4511 11.6719 14.9769 11.6719 15.623C11.6719 16.269 11.146 16.7948 10.5 16.7948ZM11.6719 12.1073C11.6719 12.7534 11.146 13.2792 10.5 13.2792C9.85398 13.2792 9.32812 12.7534 9.32812 12.1073V6.24796C9.32812 5.60195 9.85398 5.07609 10.5 5.07609C11.146 5.07609 11.6719 5.60195 11.6719 6.24796V12.1073Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningIconDynamic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-icon-dynamic.ef34a1df.svg";
export { ForwardRef as ReactComponent };